import { useMutation, useQueryClient } from "@tanstack/react-query";
import { storiesKeys } from "Api/Queries/Stories/useStoriesQuery";
import { storyPostUsageKeys } from "Api/Queries/Stories/useStoryPostUsageQuery";
import { postStoriesPublicIDPublish } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

/** First publish of a draft or re-publish of an expired story, as is. */
export const usePublishStoryMutation = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((publicID: string) =>
      postStoriesPublicIDPublish(publicID),
    ),
    onSuccess: (_: unknown, publicID: string) => {
      queryClient.invalidateQueries({ queryKey: storiesKeys.lists() });
      queryClient.invalidateQueries({ queryKey: storiesKeys.detail(publicID) });
      queryClient.invalidateQueries({ queryKey: storyPostUsageKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
